import { DateTime } from 'luxon';
import { TranslationService } from '../../../../../../../../../services/translation.service';
import { DateTimeHelper } from '../../../../../../../../../helpers/date-time.helper';

function getCancelledMessage(isCancelled: boolean, isDepartureCancelled?: boolean, isArrivalCancelled?: boolean): string | undefined {
  if (isDepartureCancelled && !isArrivalCancelled) {
    return TranslationService.get('travelplanner.exitonly');
  }
  if (!isDepartureCancelled && isArrivalCancelled) {
    return TranslationService.get('travelplanner.departshere');
  }
  if (isCancelled) {
    return TranslationService.get('common.cancelled');
  }
}

function EstimatedAndPlannedTimes({
  estimatedTime,
  plannedTime,
  isCancelled,
  isDepartureCancelled,
  isArrivalCancelled,
  className,
}: {
  estimatedTime: DateTime | undefined;
  plannedTime: DateTime | undefined;
  isCancelled: boolean;
  isDepartureCancelled?: boolean;
  isArrivalCancelled?: boolean;
  className?: string;
}) {
  if (!estimatedTime && !plannedTime) {
    return null;
  }

  const isOnTime = !estimatedTime || !plannedTime || estimatedTime.equals(plannedTime);
  const isPartiallyCancelled = (isDepartureCancelled || isArrivalCancelled) && !(isDepartureCancelled && isArrivalCancelled);

  return (
    <div className={className}>
      {!isOnTime && (
        <span>
          <span className="visually-hidden">
            {TranslationService.get('travelplanner.estimated')} {TranslationService.get('travelplanner.time')}:
          </span>
          <span>{DateTimeHelper.toTime(estimatedTime)}</span>
        </span>
      )}
      {plannedTime && (
        <span>
          <span className="visually-hidden">
            {TranslationService.get('travelplanner.planned')} {TranslationService.get('travelplanner.time')}:
          </span>
          <span className={`${!isOnTime ? 'text-decoration-line-through ms-1 text-color-gray-800' : ''} ${isCancelled && !isPartiallyCancelled ? 'text-danger text-decoration-line-through' : ''}`}>
            {DateTimeHelper.toTime(plannedTime)}
          </span>
        </span>
      )}
      {(isCancelled || isDepartureCancelled || isArrivalCancelled) && (
        <span className={`ms-1 mb-1 ${isPartiallyCancelled ? '' : 'text-danger'}`}>{getCancelledMessage(isCancelled, isDepartureCancelled, isArrivalCancelled)}</span>
      )}
    </div>
  );
}

export default EstimatedAndPlannedTimes;
